import { render, staticRenderFns } from "./disassembleDetail1.vue?vue&type=template&id=3a10cbab&scoped=true&"
import script from "./disassembleDetail1.vue?vue&type=script&lang=js&"
export * from "./disassembleDetail1.vue?vue&type=script&lang=js&"
import style0 from "./disassembleDetail1.vue?vue&type=style&index=0&id=3a10cbab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a10cbab",
  null
  
)

export default component.exports